export default __webpack_public_path__ + "static/media/icon_small_comb.7542e962.png";